import { type AllowedMaterialSpec } from 'api';
import {
  AllowedMaterialSpecAutocomplete,
  CountryAutocompleteField,
  MaterialGradeAutocomplete,
  MaterialSupportedComponentAutocomplete,
  useFormContext,
} from 'form';
import { useState } from 'react';
import { Stack } from 'ui';

export const MaterialProductsListFilters = () => {
  const form = useFormContext();
  const [materialSpec, setMaterialSpec] = useState<AllowedMaterialSpec | undefined>(undefined);

  const onMaterialSpecChange = (materialSpec: AllowedMaterialSpec) => {
    setMaterialSpec(materialSpec);
    form.setValue('material_supported_component_id', undefined);
  };

  return (
    <Stack direction="row" spacing={2} marginBottom={2}>
      <CountryAutocompleteField label="Country" name="country" />
      <AllowedMaterialSpecAutocomplete
        label="Material spec"
        name="material_spec_id"
        onSelectOption={onMaterialSpecChange}
      />
      <MaterialGradeAutocomplete label="Material grade" name="material_grade_id" />
      <MaterialSupportedComponentAutocomplete
        label="Material quality"
        name="material_supported_component_id"
        materialId={materialSpec?.material_id}
        materialColourId={materialSpec?.colour_id || undefined}
        disabled={!materialSpec}
      />
    </Stack>
  );
};
